import { useState, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Input, FormControl, FormLabel, FormErrorMessage } from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';

const PuzzleThree = () => {
    const navigate = useNavigate();
    const contextFour = useCallback(() => navigate('/BoxTwo/ContextFour'));
    const [hint, setHint] = useState('');
    const [attemptCount, setAttemptCount] = useState(0);

    const showHint = () => {
        setHint(prevHint => prevHint ? '' : 'Analyze the layout in relation to the article titles.');
    };

    const validateAnswer = (value) => {
        value = value.replaceAll(' ', '');
        if (value.toLowerCase() === 'outlet') {
            return true;
        } else {
            setAttemptCount(prev => prev + 1);
            return false;
        }
    };

    return (
        <div className="App">
            <div className="App-body">
                <h1>Puzzle Three: Articles and Layout</h1>
                {attemptCount >= 3 && (
                    <Button mt={4} bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} onClick={showHint}>
                        {hint ? 'Hide Hint' : 'Show Hint'}
                    </Button>
                )}
                {hint && <p>{hint}<br/><br/><br/></p>}

                <p>
                    As you connect the dots between the 
                    strategically placed documents, they seem to 
                    whisper of a secret held somewhere within the room itself. Could there be 
                    more than meets the eye?
                </p>

                <Formik
                    initialValues={{ answer: '' }}
                    onSubmit={(values, actions) => {
                        if (validateAnswer(values.answer)) {
                            contextFour();
                        } else {
                            actions.setFieldError('answer', 'Answer is Incorrect');
                        }
                        actions.setSubmitting(false);
                    }}
                >
                    {( props ) => (
                        <Form>
                            <Field name='answer'>
                                {({ field, form }) => (
                                    <FormControl isInvalid={form.errors.answer && form.touched.answer}>
                                        <FormLabel>Answer</FormLabel>
                                        <Input {...field} placeholder='Answer' />
                                        <FormErrorMessage>{form.errors.answer}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>
                            <Button mt={4} bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} isLoading={props.isSubmitting} type='submit'>
                                Continue
                            </Button>
                      </Form>
                    )}
                </Formik>

            </div>
        </div>
        
    );
  };
  
export default PuzzleThree;
  